import { useRegisterSW } from 'virtual:pwa-register/react';
import { addWispoPushNotifications } from '@app/notifications/api';
import { features } from '@app/base';

let isRegistrationStarted = false;

export const useServiceWorker = () => {
  useRegisterSW({
    onRegisteredSW: async (_, sw) => {
      if (sw == null) return;

      if (!features.isEnabled('WebPushNotifications')) return;

      if (Notification.permission !== 'granted') return;

      // This is required in order to avoid 2 calls to register device at the same time during development,
      // because of React.Strict mode
      if (import.meta.env.DEV) {
        if (isRegistrationStarted) return;
        isRegistrationStarted = true;
      }

      await addWispoPushNotifications();
    },
  });
};
